import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import tplHelpers from "../../helpers/tpl";

function Cancel3PLOrder(props) {

    const [orderNumberToCancel, setorderNumberToCancel] = useState("");

    const cancel3PLOrder = async() => {
        props.setLoading(true);
        try {
            await tplHelpers.cancel3PLOrder(orderNumberToCancel, props.company, props.token,);
        } catch (error) {
            console.error("Error canceling 3PL order:", error);
        } finally {
            props.setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        setorderNumberToCancel(e.target.value);
    };    


    return (
        <Box className={props.isMobile ? "mobile-top" : "desktop-top"} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box display="flex" flexDirection="column" className={props.isMobile ? "mobile-box" : "desktop-box"}>
                <h1>Cancel 3PL Order</h1>
                <Box display="flex" alignItems="center"> {/* Flexbox to align items */}
                    <TextField
                        name="order_number"
                        value={orderNumberToCancel}
                        label="Order Number"
                        onChange={handleInputChange}
                        sx={{
                            width: '15%', 
                            mr: "0.5%", 
                            height: '56px', // Ensure same height as button
                        }}
                    />
                    <Button
                        className={`${props.company} ${props.warehouse} secondary`}
                        variant="contained"
                        onClick={() => cancel3PLOrder()}
                        sx={{
                            height: '40px', // Same height as the TextField
                        }}
                    >
                        Cancel Order
                    </Button>
                </Box>
            </Box>
        </Box>
    )
    
}

export default Cancel3PLOrder;